import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedLibsModule} from '@shared/shared-libs.module';
import {SharedCommonModule} from '@shared/shared-common.module';
import {LoginComponent} from '@shared/login/login.component';
import {ListingPageComponent} from '@shared/listing-page/listing-page.component';
import {SubPageComponent} from '@shared/sub-page/sub-page.component';

import {HasAnyAuthorityDirective} from '@shared/auth/has-any-authority.directive';
import {HasAnyAuthorityDisablementDirective} from '@shared/auth/has-any-authority-disablement.directive';
import {GalleryModule} from '@ngx-gallery/core';
import {LightboxModule} from '@ngx-gallery/lightbox';
import {GallerizeModule} from '@ngx-gallery/gallerize';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    RouterModule,
    SharedLibsModule,
    SharedCommonModule,
    GallerizeModule,
    LightboxModule,
    GalleryModule,
    TranslateModule,
  ],
  declarations: [
    LoginComponent,
    HasAnyAuthorityDirective,
    HasAnyAuthorityDisablementDirective,
    ListingPageComponent,
    SubPageComponent,
  ],
  providers: [],
  exports: [
    SharedCommonModule,
    LoginComponent,
    HasAnyAuthorityDirective,
    HasAnyAuthorityDisablementDirective,
    TranslateModule,
    ListingPageComponent,
    SubPageComponent,
  ],
})
export class SharedModule {}
